<template>
  <div class="tenant-level-settings">
    <div class="mb-0 module-header v-center space-between">
    <div class="v-center gap-1">
      <img class="btn-icon" src="~@/assets/images/settings.svg" alt="" />
      <h1 class="module-name">Tenant Level Settings</h1>
    </div>
    </div>
    <div class="tenant-container">
      <div class="tenant-settings-bar">
        <tenant-settings-list/>
      </div>
      <div class="tenant-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import tenantSettingsList from '../../components/settings/tenantList.vue'
export default {
  name: 'Settings',
  data () {
    return {
      loading: false
    }
  },
  components: {
    tenantSettingsList
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.module-header.mb-0 {
  margin-bottom: 0;
  flex-shrink: 0;
}
.tenant {
  height: 100%;
  &-level-settings {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    & .btn-icon {
      filter: invert(68%) sepia(85%) saturate(388%) hue-rotate(1deg) brightness(92%) contrast(88%);
    }
  }
  &-container {
    flex: 1;
    min-height: 0;
    height: calc(100% - 60px);
    overflow: hidden;
    display: flex;
    & > div {
      height: 100%;
    }
  }
  &-settings-bar {
    width: 240px;
    min-width: 240px;
    flex-shrink: 0;
    height: 100%;
    overflow: hidden;
  }
  &-settings-list {
    width: 100%;
    height: 100%;
  }
  &-content {
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
  }
}
</style>
